export default "__VITE_ASSET__BNTa3GCA__"